export const KEY_PEOPLE = 'people'

const getInitialState = () => ({})

export const setInitialState = (state) => {
  state[KEY_PEOPLE] = getInitialState()
  return state
}
